import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const GiftLazy = loadable(() => import(/* webpackChunkName: "Gift" */ './GiftSuspense'));

export const GiftAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <GiftLazy />
    </DelayedSuspense>
);
